import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/bim360-matrix-react-button';
import SelectBox from '@adsk/bim360-matrix-react-select-box';
import i18n from '../../utils/i18n';
import {templateCategoryType} from '../../constants/proptype-validation';

const TemplateCategorySelectBox = ({value, options, invalid, disabled, onChange, container, onCreateNewClicked}) => {
  const textNoCategories = i18n.t('createTemplate.noCategories');
  const textNotFound = i18n.t('createTemplate.noCategoriesFound');
  const noResultText = options && options.length > 0 ? textNotFound : textNoCategories;
  return (
    <SelectBox
      container={container}
      value={value}
      options={options}
      isOptionDisabled={({isActive}) => !isActive}
      labelKey="title"
      valueKey="id"
      invalid={invalid}
      disabled={disabled}
      onChange={onChange}
      noResultsValue={<div>
        <span>{noResultText}</span>
        {
          <span>
            {' '}
              -{' '}
            <Button styleType={Button.StyleType.INLINE_LINK} onClick={onCreateNewClicked}>
              {i18n.t('createTemplate.createNew')}
            </Button>
          </span>
        }
      </div>}
      clearable
      searchable
      searchPlaceholder={i18n.t('new.search')}
    />
  );
};

TemplateCategorySelectBox.displayName = 'TemplateCategorySelectBox';

TemplateCategorySelectBox.propTypes = {
  value: templateCategoryType,
  options: PropTypes.arrayOf(templateCategoryType).isRequired,
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onCreateNewClicked: PropTypes.func.isRequired,
  container: PropTypes.object
};

export default TemplateCategorySelectBox;
